import { render, staticRenderFns } from "./SerialItemReport.vue?vue&type=template&id=d9c9f438&"
import script from "./SerialItemReport.vue?vue&type=script&lang=js&"
export * from "./SerialItemReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports